<div odxLayout="grid" [formGroupName]="groupName">
  <span odxLayout="10 4@desktop 5@tablet" class="odx-text">{{ label }}</span>
  <odx-switch
    odxLayout="2 1@tablet"
    formControlName="checked"
    [readonly]="(isReadOnlyUser$ | async) === true || (hasWritePermission$ | async) === false"
  >
  </odx-switch>
  <odx-form-field
    odxLayout="12 5@desktop 6@tablet"
    [readonly]="(isReadOnlyUser$ | async) === true || (hasWritePermission$ | async) === false || disabled"
  >
    <textarea formControlName="notes" odxFormFieldControl [placeholder]="notesPlaceholder"></textarea>
  </odx-form-field>
</div>
